export default __webpack_public_path__ + "static/media/le_lion8.2247bafd.jpg";